export const locale = {
    lang: 'de',
    data: {
      'PRINCIPAL': {
        'TITULO': 'Umfragestatus',
        'SUBTITULO': 'Sie können die Informationen der Umfragen, die in einem oder mehreren Produkten des Unternehmens angewendet wurden, überprüfen und nachverfolgen',
        'COPY_URL_RES':'URL von SuccesGo kopieren',
      },
      'MENU_PRODUCTOS': {
        'TITULO': 'Gekaufte Produkte',
        'CARGANDO': 'Laden der Produktliste',
        'NOMBREPULSO': 'Impuls',
        'TIPOS': {
          'certificar': {
            'NOMBRE': 'Bestätigen',
            'SUBTIPOS': {
              'v1': 'Zertifizieren v1',
              'v2': 'Zertifizieren v2.0',
              'v3': 'Zertifizieren v3.0',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': 'Zusätzliche Zertifizierungen',
            'SUBTIPOS': {
              'v1Amco': 'AMCO',
              'v2TD': 'Anständige Arbeit',
              'v3PE': 'Erster Job',
            }
          },
          'medir': {
            'NOMBRE': 'Messen',
            'SUBTIPOS': {
              'v1': 'Messen v1',
              'v2': 'Maßnahme verbessert',
              'v3': 'Messen + MST',
              'v4': 'Nach Bereichen messen',
              'v5': 'Messen nach Führungskräften',
              'v6': 'Nach Maßen messen',
              'v7': 'Maßnahme zur Zertifizierung',
              'v8': '3.0 . messen',
            }
          },
          'pulse': {
            'NOMBRE': 'Drücken Sie das Häkchen',
            'SUBTIPOS': {
              'v1': 'Puls-Check v1.0',
              'v2': 'Pulscheck v3.0',
            }
          },
          'focus': {
            'NOMBRE': 'Fokusbereich',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': 'Kultureller Go-Express',
            'SUBTIPOS': {
              'cgoExpress': 'Kultureller Go-Express'
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow-Ergebnisse',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow-Ergebnisse'
            }
          },
        }
      },
      'DETALLES': {
        'TITULO': 'Produktdetails',
        'PRODUCTO': 'Produkt:',
        'PROGRESO': 'Fortschritt',
        'RESTANTE': 'Verbleibende Zeit',
        'DIASREST': 'Verbleibende Tage:',
        'PANELFIJO': 'Als festes Panel anzeigen',
        'SURVEYTOKEN': 'Umfrage-Token',
        'ACCOUNT_ID': 'Konto-ID',
        'OPORTUNITY_ID': 'Opportunitäts-ID',
        'FECHAS': {
          'lanzamiento': 'Veröffentlichungsdatum',
          'cierre': 'Frist',
          'prorroga': 'Verlängerungsdatum',
          'recordatorio':'Mahnungen',
          'avisos':'Kommunikation vor der Umfrage',
        },
        'AVANCES': {
          'NORMAL': 'Vorab-Antworten:',
          'MAS50': 'Vorsprung über 50:',
          'MAS50_2': 'Über 50 - Vorab-Antworten',
          'MENOS50': 'Vorschuss unter 50:',
          'MENOS50_2': 'Weniger als 50 – Vorausantworten'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': 'Wählen Sie ein Produkt',
          'VERPROD_2': 'Anderes Produkt ansehen',
          'OCULTAR': 'Ausblenden'
        },
        'PREVIA': {
          'TITULO': 'Umfragestatus nach Produkt',
          'SUBTITULO': 'Die Liste der von diesem Unternehmen gekauften Produkte wird im Menü auf der linken Seite dieses Bildschirms angezeigt. Um den Umfragestatus für jedes Produkt anzuzeigen, klicken Sie auf eine Produktkategorie und wählen Sie dann ein Jahr aus. Danach werden die Details der ausgewählten Umfrage nur angezeigt, wenn das ausgewählte Produkt bereits eine initialisierte Umfrage hat has',
          'CARGANDO': 'Status des ausgewählten Produkts wird abgerufen, bitte warten'
        },
        'ESTADOS': {
          'NOCREADA': 'Für dieses Produkt wurde noch keine Umfrage erstellt',
          'NOINICIADA': 'Umfrage nicht aktiviert'
        },
      },
      'COLABORADORES': {
        'TAB': 'Liste der Mitarbeiter',
        'CARGANDO': 'Liste der Mitarbeiter wird geladen',
        'TABLA': {
          'TITULO': 'Liste der Mitarbeiter',
          'NOINFO': 'Keine Information',
          'COLUMNAS': {
            'NOMBRE': 'Vollständiger Name',
            'EMAIL': 'Email',
            'PASS': 'Passwort',
            'STATUS': 'Tatsächlicher Zustand',
            'FECHA_INI': 'Anfangsdatum',
            'FECHA_FIN': 'Enddatum',
            'ACCIONES': 'Aktionen'
          },
          'TOOLTIPS': {
            'ACCIONES': 'Verfügbare Aktionen',
            'EMAILS': 'E-Mail-Protokoll',
          },
        },
        'ACCIONES': {
          'TITULO': 'Verfügbare Aktionen',
          'LISTA': {
            'primerosColab': 'Siehe erste 1000',
            'buscarColab': 'Finden Sie einen Mitarbeiter',
            'nuevoColab': 'Neuen Mitarbeiter hinzufügen',
            'enviaReco': 'Erinnerungen senden',
            'bajarColab': 'Liste der Mitarbeiter herunterladen',
          }
        },
        'SENDGRID': {
          'TITULO': 'E-Mail-Protokoll gesendet',
          'SUBTITULO': 'Wählen Sie einen Betrefftyp aus der Liste aus, um den Verlauf der gesendeten E-Mails anzuzeigen',
          'SELOPC': 'Wähle eine Option',
          'INFOASUNTO': {
            'TITULO': 'E-Mail-Informationen',
            'CARD': {
              'from': 'Senden an',
              'to': 'Von',
              'subject': 'Betreff der Nachricht'
            },
            'HISTORIAL': {
              'TITULO': 'Verlauf der E-Mail-Übermittlung',
              'SUBTITULO': 'HINWEIS: Das in der Liste angezeigte Datum / die Uhrzeit wird auf die Ortszeit von',
              'VECESABIERTO': 'Öffnungszeiten',
              'ULTIMOEVENTO': 'Letzte Veranstaltung',
              'NORECORDS': 'Ihr E-Mail-Verlauf ist nicht verfügbar',
              'STATUS': {
                'ABIERTO': 'E-Mail gesendet',
                'NOENVIADO': 'Noch nicht versendet'
              }
            }
          },
          'BOTONES': {
            'BACK': 'Geh zurück'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': 'Verfügbare Aktionen',
          'SUBTITULO': 'Die folgende Liste zeigt die Liste der Aktionen, die dem Benutzer zur Verfügung stehen',
          'CARGANDO': 'Verfügbare Aktionen werden geladen',
          'LISTA': {
            'modificar': 'Ändern Sie die Daten des ausgewählten Mitarbeiters',
            'borrar': 'Löschen Sie den ausgewählten Mitarbeiter',
            'invitacion': 'Einladung erneut versenden',
            'recordatorio': 'Erinnerung erneut senden',
            'respuestas': 'Umfrageantwort entfernen',
            'resetSur': 'Umfragezugang zurücksetzen',
          }
        },
        'MODALES': {
          'BUSCAR': 'Geben Sie den Namen des zu suchenden Mitarbeiters ein',
          'BUSCAR_BOT': 'Suche',
          'MINIMARECO': 'Erinnerungen können nur ab dem Startdatum der Umfrage gesendet werden',
          'GENERAEXCEL': 'Generieren einer Excel-Datei von Mitarbeitern, warten Sie einen Moment',
          'NOANSWERS': 'Für diesen Teilnehmer wurden keine Antworten gefunden',
          'ENVIOCORREO': 'Senden Sie die Nachricht, warten Sie einen Moment',
          'BORRARESP': 'Antworten von diesem Benutzer werden gelöscht, bitte warten Sie einen Moment',
        },
        'EXCEL': {
          'TITUARCHIVO': 'Liste der Mitarbeiter',
          'COLUMNAS': {
            'name': 'Mitarbeitername Col',
            'email': 'Email',
            'id_status': 'Umfragestatus',
            'start_date': 'Anfangsdatum',
            'end_date': 'Enddatum',
          }
        }
      },
      'ACCIONES': {
        'TAB': 'Aktionen',
        'TITULO': 'Liste der verfügbaren Aktionen nach Kategorie',
        'CATEGORIAS': {
          'encuesta': 'Umfrage',
          'filemanager': 'Dateimanager',
          'resultados': 'Ergebnisse',
          'webcompro': 'Unternehmensprofil im Internet',
        },
        'LISTA': {
          'surveyCheck': 'Überprüfung der Umfrage',
          'surveyDown': 'Umfrage herunterladen',
          'goSurvey': 'Zur Umfrage gehen',
          'goCounting': 'Gehe zum Zählportal',
          'goCounting_more50': 'Gehe zum Zählportal +50',
          'goCounting_less50': 'Gehe zum Zählportal -50',
          'genCountingUrl': 'Externen Link zum Counts Portal erstellen',
          'copyCountingUrl': 'Externen Link zum Counts-Portal kopieren',
          'updateCounting': 'Mit dem Counts-Portal synchronisieren',
          'addPro': 'Erweiterung hinzufügen',
          'verRecord': 'Aufgezeichnete Erinnerungen',
          'surveyClose': 'Umfrage schließen',
          'surveyOpen': 'Umfrage öffnen',
          'processRes': 'Prozessergebnisse',
          'goPriv': 'Privaten Ordner anzeigen',
          'goPub': 'Öffentlichen Ordner anzeigen',
          'verRes': 'Ergebnisse anzeigen',
          'upNameIcon': 'Name und Logo aktualisieren',
          'regCertifi': 'Zertifikat neu generieren',
          'goSurveyMas50': 'Gehe zu Umfrage +50',
          'goSurveyMenos50': 'Gehe zu Umfrage -50',
          'auditMan': 'Manuelle Prüfung',
          'libeCultureBrief': 'Kultur Kurzmitteilung',
          'lockRes': 'Ergebnisse sperren',
          'verCultureAudit': 'Siehe Kulturaudit',
          'verAvisos':'Kommunikation vor der Erhebung',
          'enviaCorreos': 'E-Mails manuell senden',
          'verWebComPro': 'Unternehmensprofil im Internet ansehen',
          'verFechIniCie': 'Start-/Enddatum',
          'cancelarEnvios': 'E-Mail-Versand abbrechen',
          'verConfigResult': 'Ergebniskonfiguration',
          'descaDemo': 'Demografische Daten zum Herunterladen zulassen',
          'crearClave':'Schlüssel zu externem Firmenprofil generieren',
          'copyClave':'Schlüssel in externes Unternehmensprofil kopieren',
          'verDatWPC':'Zugangsdaten zum externen Unternehmensprofil anzeigen',
          'confirReviCultureAudit':'Bestätigen Sie die Überprüfung des Kulturaudits',
        },
        'MODALES': {
          'URL': 'Link in die Zwischenablage kopiert',
          'URL_CLA': 'Der Schlüssel wurde in die Zwischenablage kopiert',
          'CHANGE_RESULT':'Ergebnisse laden',
          'LOADINGMASTER': 'Abrufen von Informationen aus der Master-Tabelle, bitte warten Sie einen Moment',
          'CONFIR_UPDA_NAM':'Sind Sie sicher, dass Sie den Namen und das Logo aktualisieren möchten?',
          'CONFIR_REG_CERT':'Sind Sie sicher, dass Sie das Zertifikat regenerieren wollen?',
          'SUCC_UPDA_NAME':'Erfolgreich aktualisiert',
          'UPDA_NAME_ICON':'Daten aktualisieren',
          'UPDA_STA_ENC':'Aktualisierung des Umfragestatus',
          'OBT_DAT_AUD_AUT':'Einholung von Prüfungsinformationen',
          'WARNI_NOT_EXIT_TOKEN':'Fehler: Token existiert nicht in MT',
          'CONFIR_REPRO_RESULT':'Sind Sie sicher, dass Sie die Ergebnisse neu verarbeiten wollen?',
          'MOD_INGRE_COD_PT1':'<span> Geben Sie zur Bestätigung den Code in Rot in das Textfeld ein ',
          'MOD_INGRE_COD_PT2':'</span>',
          'ERROR_CODIGO': 'Der eingegebene Code stimmt nicht mit dem rot markierten überein',
          'CONFIR_LIBE_CULT_BRI':'Sind Sie sicher, dass Sie den Kulturauftrag freigeben wollen?',
          'CONFIR_REVI_CULT_AUDIT':'Sind Sie sicher, dass Sie die Überprüfung des Kulturaudits bestätigen wollen?',
          'NO_CONFIR_REVI_CULT_AUDIT':'Sind Sie sicher, dass Sie die Überprüfung des Kulturaudits abbrechen wollen?',
          'NO_CULT_BRI_ASOC':'Es kann kein Kultur-Audit-Partner gefunden werden',
          'BLOQUEAR_1_1': 'Die Ergebnisse sind derzeit entsperrt. \nMöchten Sie die Ergebnisse sperren?',
          'BLOQUEAR_1_2': 'Geben Sie den Grund ein, warum die Ergebnisse gesperrt wurden',
          'BLOQUEAR_2_1': 'Die Ergebnisse sind derzeit gesperrt \nMöchten Sie die Ergebnisse entsperren?',
          'BLOQUEAR_2_2': 'Schreiben Sie den Grund, warum die Ergebnisse freigeschaltet wurden',
          'BLOQUEAR_3_1': 'Es ist notwendig, den Grund für die Änderung anzugeben',
          'SINCRONIZARMT': 'Die Daten der Mastertabelle werden synchronisiert, bitte warten Sie einen Moment',
          'UPDA_DAT_RECOR': 'Aktualisieren des Erinnerungsdatums',
          'DELE_DAT_RECOR': 'Löschen des Erinnerungsdatums',
          'UPDA_DAT_AVI': 'Hinweis Datumsaktualisierung',
          'DELE_DAT_AVI': 'Wegfall des Kündigungstermins',
          'CANCELAR_ENVIOS': 'Möchten Sie geplante E-Mails wirklich stornieren?',
          'CANCELAR_ENVIOS_OK': 'Die Sendung wurde erfolgreich storniert.',
          'CANCELAR_ENVIOS_ERROR': 'Eine Stornierung der Lieferung weniger als zwei Stunden vor dem Start der Umfrage ist nicht möglich.',
          'COM_CRE_ACCE_WCP_EXT': 'Sind Sie sicher, dass Sie den Schlüssel für das Unternehmensprofil erstellen wollen?',
          'CRE_ACCE_WCP_EXT': 'Kennwort wird generiert',
          'SUCC_CRE_ACCE_WCP_EXT': 'Passwort erfolgreich generiert',
          'TIT_MOD_VALI_ACCE_WCP_EXT': 'Zum Fortfahren: Geben Sie Ihr Passwort ein',
          'PLA1_MOD_VALI_ACCE_WCP_EXT': 'Sie haben derzeit noch ',
          'PLA2_MOD_VALI_ACCE_WCP_EXT': ' Versuche',
          'BTN_ACEP': 'Akzeptieren',
          'BTN_CAN': 'Abbrechen',
          'WAR_ACCE_WCP_EXT': 'Das eingegebene Passwort ist nicht korrekt',
          'LIMI_ACCE_WCP_EXT': 'Sie haben das Limit der Versuche erreicht',
          'DESAC_ACCE_WCP_EXT': 'Ihr Unternehmensprofil ist derzeit deaktiviert',
          'ACTU_ACCE_WCP_EXT': 'Informationen werden aktualisiert',
          'SUCC_ACTU_ACCE_ACCE_WCP_EXT': 'Erfolgreich aktualisiert',
          'CHANGE_WCP':'Unternehmensprofil laden',
        },
        'SUBACCIONES': {
          'TITULO': 'Klicken Sie hier, um weitere verfügbare Aktionen anzuzeigen',
          'AUDMANUAL': {
            'TITULO': 'Manuelle Prüfung',
            'NOMBRE': 'Name des Prüfers',
            'NOTAS': 'Beobachtungen',
            'STATUS': {
              'ON': 'Prüfung akzeptiert',
              'OFF': 'Prüfung abgelehnt'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': 'Versionstyp der Ergebnisse ändern',
              'MODAL': {
                'TITULO': 'Auswahl des Versionstyps',
                'SUBTITULO': 'Wählen Sie die Art der Ergebnisversion für dieses Produkt aus',
                'SINCERT': 'Version ohne Zertifikat',
                'CONCERT': 'Version mit Zertifikat'
              }
            },
            'tipoResuV2': {
              'TITULO': 'Siehe Ergebnisse Version 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': 'Zertifikatslogo ändern',
            },
            'previewCert': {
              'TITULO': 'Zertifikatsvorschau',
            },
            'multiSite': {
              'TITULO': 'Zertifikatstext für mehrere Standorte aktivieren',
            },
            'multiSiteText': {
              'TITULO': 'Zertifikatstext für mehrere Standorte anzeigen',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': 'Firmenlogo ändern'
            },
            'previewLogoEmp': {
              'TITULO': 'Logo-Vorschau'
            },
            'updateDatCerti': {
              'TITULO': 'Datum der Bescheinigung ändern',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': 'Mastertabelle synchronisieren'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': 'Status siehe externes Firmenprofil',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': 'Status siehe externes Firmenprofil',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': 'Status siehe Unternehmensprofil auf der Website',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'Öffentlich',
              'ESTA_WPC_NPU':'Nicht-öffentlich',
            },
          },
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': 'Verlauf der gesendeten E-Mails',
        'TITULO': 'Liste der für dieses Produkt gesendeten E-Mails sent',
        'TABLA': {
          'DESTINATARIO': 'Adressat',
          'ASUNTO': 'E-Mail-Betreff',
          'ESTADO': 'Aktueller Status',
          'VECES': 'Anzahl der Öffnungen',
          'ULTIMO': 'Datum der letzten Veranstaltung',
          'FILTRO': 'Filter',
          'INPUT_DEST': 'Nach E-Mail-Adresse filtern',
          'INPUT_ASU': 'Nach Thema filtern',
          'INPUT_STAT': 'Nach Status filtern',
          'ELIJAOPCION': '- Wählen Sie eine Option aus der Liste -',
          'NORESULTS': 'Keine Aufzeichnungen gefunden',
          'LISTA_STATUS': {
            'delivered': 'Geschickt',
            'processed': 'Im Versandprozess',
            'not_delivered': 'Nicht gesendet'
          }
        },
        'ACCIONES': {
          'TITULO': 'Verfügbare Aktionen',
          'LISTA': {
            'enviaCorreos': 'E-Mails manuell senden',
            'getEnviados': 'E-Mail-Versandverlauf aktualisieren',
          }
        },
        'MODAL': {
          'TITULO': 'Manueller Versand',
          'SUBTITULO': 'Sie können sofort manuelle Mailings eines bestimmten Typs an die Mitarbeiter dieser Umfrage senden',
          'INPUT': 'Wählen Sie einen E-Mail-Typ aus',
          'TIPOS': {
            '1': 'Einladungs-E-Mail',
            '2': 'Erinnerungsmail',
            '3': 'Erster Hinweis vor dem Start der Umfrage',
            '4': 'Zweite Benachrichtigung vor dem Start der Umfrage',
            '5': 'Abschlussmail',
            '6': 'Mail an Mitarbeiter, die die Umfrage noch nicht gestartet haben',
            '7': 'E-Mail an Mitarbeiter, die begonnen, aber noch nicht fertig sind'
          },
          'BOTONES': {
            'BACK': 'Geh zurück',
            'CONTINUAR': 'Weitermachen',
            'SAVE': 'Audit speichern',
          }
        },
        'MODALES': {
          'RECUPERANDO': 'Liste der gesendeten E-Mails abrufen, warten Sie einen Moment',
          'SEND_EMA':'Mails werden gesendet',
          'SUCC_SEND_EMA':'Die Mails wurden erfolgreich versendet',
          'CONFIRMAR': 'Bestätigen Sie das Senden der E-Mails des ausgewählten Typs an die Mitarbeiter dieser Umfrage?',
          'ENVIADOS': 'Die E-Mails wurden erfolgreich gesendet, aktualisieren Sie in Kürze den Verlauf, um die gesendeten E-Mails zu sehen',
          'SI': 'Jawohl',
          'NO': 'Nein',
          'UPDAT_HIST_EMA': 'Aktualisierung der Historie',
          'SUCC_UPDAT_HIST_EMA': 'Erfolgreich aktualisiert',
          'WAR_SEL_MAI': 'Um fortzufahren, wählen Sie einen Mail-Typ',
          'WAR_SQL_ERROR': 'Die Antwortzeit ist abgelaufen, bitte versuchen Sie es erneut',
        },
        'RESUMEN': {
          'TITULO': 'Zusammenfassung',
          'TIPOS': {
            'totalEnviados': 'Mailings insgesamt gestartet',
            'delivered': 'Richtige Mailings',
            'processed': 'Mailings in Bearbeitung',
            'not_delivered': 'Mailings nicht gemacht',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'Umfrage-Audit',
        'TEX_AUDI_NOT_AUTORI': 'Prüfung abgelehnt!',
        'TEX_AUDI_YE_AUTORI':'Audit akzeptiert!',
        'TITL_AUDI_DEV_TR':'% Dev.Time Response',
        'TITL_AUDI_DEV_PC':'% Dev. Frage Kontrolle',
        'TITL_AUDI_DEV_PA':'% Dev. Zufallsfrage Random',
        'TIT_PAGI_TABL':'Artikel pro Seite:',
        'COLUMNAS':{
          'HierarchicalPath':'Struktur',
          'RespondentCount':'# Antworten',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.Kontrolle',
          'ControlStatement_DeviationPercentage':'% Desv P.Kontrolle',
          'RandomStatement_DeviationPercentage':'# Desv P.Zufällig',
          'RandomStatement_DeviationCount':'% Desv P.Zufällig',

        }
      },
      'EMAI_LOG':{
        'TAB':'Allgemeiner Mailverlauf',
        'TABLA_GLOBAL':{
          'TITU':'Globale Anzeige',
          'SUB_TIT':'Beitragende insgesamt',
          'TH_1':'Status',
          'TH_2':'Erste Meldung',
          'TH_3':'Zweite Meldung',
          'TH_4':'Einladung',
          'TH_5':'Erinnerung an nicht gestartete Benutzer',
          'TH_6':'Erinnerung für nicht beendete Benutzer',
          'enviados':'Gesendet',
          'procesando':'Bearbeitung',
          'error':'Fehler',
          'VIE_DETA_TOOL':'Details anzeigen',
        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': 'Anzeige der gesendeten Mails vom Typ Warnung 1',
          'TITU_AV1_PROCC':'Anzeige Mailtyp Benachrichtigung 1 in Bearbeitung',
          'TITU_AV1_N_DELIV':'Anzeige Mailtyp Warnung 1 im Fehlerfall',
          'TITU_AV2_DELIV': 'Anzeige Typ Mail Warnung 2 gesendet',
          'TITU_AV2_N_DELIV':'Art der Mailwarnung 2 im Fehlerfall anzeigen',
          'TITU_AV2_PROCC': 'Anzeige Typ 2 Benachrichtigung 2 Mail in Bearbeitung',

          'TITU_INV_DELIV':'Anzeige Typ Mail Einladung gesendet',
          'TITU_INV_PROCC': 'Art der in Bearbeitung befindlichen Einladungsmail anzeigen',
          'TITU_INV_N_DELIV': 'Art der Einladungsmail im Fehlerfall anzeigen',

          'TITU_REC1_DELIV':'Anzeige Erinnerungsmail Typ 1 gesendet',
          'TITU_REC1_PROCC':'Anzeige Erinnerungsmail Typ 1 in Bearbeitung',
          'TITU_REC1_N_DELIV':'Erinnerungsmail Typ 1 fehlerhaft anzeigen',

          'TITU_REC2_DELIV':'Anzeige Erinnerungsmail Typ 2 gesendet',
          'TITU_REC2_N_DELIV':'Erinnerungsmail Typ 2 fehlerhaft anzeigen',
          'TITU_REC2_PROCC': 'Erinnerungsmail Typ 2 in Bearbeitung anzeigen',
          'SUB_TIT':'Mitarbeiter insgesamt',
          'TH_1':'Status',
          'TH_2':'Name des Mitwirkenden',
          'TH_3':'Nachricht',
          'TH_4':'Datum der letzten E-Mail',
          'TH_5':'E-Mails insgesamt',
          'TH_6':'Aktion',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounce',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'Name oder E-Mail eingeben',

        },
        'TEX_MOD_CHA_INFO':'Informationen laden',
        'CONT_MOD':{
          'TAB_TIT1': 'Mail-Status',
          'TAB_TIT2':'Mail-Ansicht',
          'TEX_CHA_INFO_GRAL':'Informationen laden',
          'TEX_ASUN':'Betreff: ',
          'TEX_SELEC_EMA':'Eine E-Mail auswählen',
          'TEX_CHA_INFO_EMA':'E-Mail-Informationen werden geladen',
          'H1_TIT_EMA_INFO':'E-Mail-Informationen',
          'SPAN_SUB_TIT_DET':'Details',
          'TO':'An:',
          'FROM':'Von:',
          'SUBJE':'Betreff',
          'MESS_ID':'Nachrichten-ID:',
          'BTN_VER_MAS':'Weitere Einzelheiten',
          'BTN_VER_MEN':'Weniger Einzelheiten',
          'TIT_TEX_LIS':'Ereignisverlauf',
          'SPAN_RECIV_SENGR':'Empfangen von SendGrid',
          'SPAN_RECIV_FROM':'Empfangen von',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounce',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'Der Empfänger hat diese E-Mail geöffnet',
          'REASON':{
           'Bounced Address':'Geplatzte Adresse',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD': 'Datum der Änderung des Zertifikats',
        'ING_DAT':'Datum auswählen:',
        'ING_RAS':'Grund für die Änderung des Datums eingeben:',
        'BTN_SAV':'Änderungen speichern',
        'BTN_OK':'OK',
        'MOD_ING_REA':'Grund für die Datumsänderung eingeben',
        'MOD_UPD_DAT':'Datum der Aktualisierung des Zertifikats',
        'SUCC_MOD_UPD_DAT':'Erfolgreich aktualisiert',

      },
      'DAT_STAEND':{
        'TIT_MOD':'Start- und Enddatum der Umfrage',
        'SUB_TIT_MOD':'Jedes Datum wird in Ortszeit in ',
        'TEX_DA_STA':'Startdatum',
        'TEX_DA_EN':'Enddatum',
        'MOD_UPD_DA_DA_STA':'Aktualisierung des Freigabedatums',
        'MOD_UPD_DA_EN':'Aktualisierung des Enddatums',
        'SUCC_MOD_UPD_DA_DA_STA':'Erfolgreich aktualisiert',
        'SUCC_MOD_UPD_DA_DA_EN':'Erfolgreich aktualisiert',


      },
      'LANG_CERT':{
        'TIT_MOD':'Sprache auswählen:',
      },
    }
};
